import { render, staticRenderFns } from "./PressRelease.vue?vue&type=template&id=2585efc7&scoped=true&"
import script from "./scripts.js?vue&type=script&lang=js&"
export * from "./scripts.js?vue&type=script&lang=js&"
import style0 from "./PressRelease.vue?vue&type=style&index=0&id=2585efc7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2585efc7",
  null
  
)

export default component.exports